import { HazardLightsIcon } from './HazardLightsIcon';

/**
 * author: Michael Irigoyen
 * id AEB30C8D-5159-4897-8D17-6EFB9715D3CD
 * name hazard-lights
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hazard-lights.svg
 * tags
 * - Automotive 
 */
export const WarningLightsIcon = HazardLightsIcon;
export default WarningLightsIcon